import { useEffect, useState } from 'react';

let cachedResult: boolean | null = null;
const listeners = new Set<(v: boolean) => void>();

function notify(value: boolean) {
	cachedResult = value;
	listeners.forEach((l) => {
		l(value);
	});
}

function measure() {
	if (cachedResult !== null) return;

	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		return notify(false);
	}

	const conn = (navigator as any).connection;
	if (conn && ['slow-2g', '2g'].includes(conn.effectiveType)) {
		return notify(false);
	}

	let frames = 0;
	const start = performance.now();

	const tick = () => {
		if (performance.now() - start < 1000) {
			frames++;
			requestAnimationFrame(tick);
		} else {
			notify((frames / (performance.now() - start)) * 1000 >= 30);
		}
	};

	requestAnimationFrame(tick);
}

export function usePerformant() {
	const [capable, setCapable] = useState<boolean>(cachedResult ?? false);

	useEffect(() => {
		if (cachedResult !== null) {
			setCapable(cachedResult);
			return;
		}

		listeners.add(setCapable);
		measure();

		return () => {
			listeners.delete(setCapable);
		};
	}, []);

	return capable;
}
